interface IHsf012TrackingGlobals {
	postSlug: string;
	postTitle: string;
	sfWebsiteCode: string;
	sfCode: string;
	sfStandortKurz: string;
	themenweltKurz: string;
	pageType: string;
}

declare global {
	interface Window {
		// eslint-disable-next-line camelcase
		___hsf012tracking_globals: IHsf012TrackingGlobals;
	}
}

const globals = window.___hsf012tracking_globals;

export default globals;
